<template>
  <!-- <div @click="opendetailrightsidebar"><i class="pi pi-bars"></i></div> -->
  <div :style="{ width: sidebarwidth }" class="rightdetailssidebar" v-if="trigger">
    <div class="firstcontent">
      <div class="sidebar-header">
        <h6>Asset Details</h6>
        <i class="pi pi-times" @click="closedetails()"> </i>
      </div>
      <div class="sidebar-content">
        <AssetDetailsComponents :assetDetailsList="assetDetailsList" />
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import {
  defineComponent,
  ref,
  onMounted,
  onUnmounted,
  computed,
  watch,
} from "vue";
import { useI18n } from "vue-i18n";
import TextField from "../../../../../../../../components/FormComponents/TextInput.vue";
import CustomDropDownfield from "../../../../../../../../components/FormComponents/Dropdown.vue";
import CustomDatepicker from "../../../../../../../../components/FormComponents/DatePicker.vue";
import NormalTableview from "../../../../../../../../components/FormComponents/NormalTable.vue";
import Footer from "../../../../../../../../components/FormComponents/Footer.vue";
import {
  ScanItemModel,
  AgreementList,
} from "../../../../../../../../modules/Inventory/pages/AssetManagement/Transaction/model/AssetInitialSetup/scanItemModel";
import AgreementComponents from "../../../../../../../../modules/Inventory/pages/AssetManagement/Transaction/components/agreementComponents.vue";
import Textarea from "../../../../../../../../components/FormComponents/TextArea.vue";
import AssetMasterService from "../../../../../../../../modules/Inventory/Service/AssetManagement/AssetMasterService";
import moment from "moment";
import { useRoute, useRouter, onBeforeRouteUpdate } from "vue-router";
import AssetDetailsComponents from "../../../../../../../../modules/Inventory/pages/AssetManagement/Transaction/components/assetDetailsComponents.vue";

export default defineComponent({
  props: {
    trigger: {
      type: Boolean,
      default: true,
    },
    assetDetailsList: {
      type: Object,
      required: true,
      default: () => ({})
    },
    // asset: {
    //     type: Object,
    //     required: true
    // }
  },
  components: {
    Textarea,
    Footer,
    TextField,
    CustomDropDownfield,
    CustomDatepicker,
    NormalTableview,
    AgreementComponents,
    AssetDetailsComponents,
  },
  setup(props, { emit }) {
    const showdetailrightsidebar = ref(false);
    const showdetails = ref(false);
    const loading = ref(false);
    const show = ref();
    const { t } = useI18n();
    const getassetDetailsList: any = ref([]);
    const sidebarwidth = computed(() => {
      return showdetails.value ? "65rem" : "35rem";
    });

    let scannedItems: any = ref([{}]);
    let assetDetailsItems: any = ref([{}]);
    let selectedProduct: any = ref([]);

    const route = useRoute();

    const data = route.query.data as string;
    const queryform = JSON.parse(data);
    // if (model.value != null) {
    //     IsEdit();
    // } else {
    //     IsCreate();
    // }
    // function opendetailrightsidebar() {
    //     showdetailrightsidebar.value = true;
    // }
    function closedetailsrightsidebar() {
      showdetailrightsidebar.value = false;
      // showdetails.value = false;
      // emit("triggerclose")
    }
    watch(
      () => props.assetDetailsList,
      (newVal: any) => {
        debugger;
        getAssetDetails();
      }
    );
    async function getAssetDetails() {
      const data_response = await AssetMasterService.getByAssetIdDetails(
        props.assetDetailsList.AssetId || props.assetDetailsList.Id
      );
      console.log(data_response["result"]);
      getassetDetailsList.value = data_response["result"];
    }

    const headers = [
      {
        header: t("assetManagement.MassConverstion.serialNumber"),
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: t("assetManagement.MassConverstion.itemName"),
        field: "Code",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("assetManagement.MassConverstion.assetType"),
        field: "Name",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("assetManagement.MassConverstion.location"),
        field: "Name",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: "",
        field: "action",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
    ];
    const assetDetailsheaders = [
      {
        header: t("assetManagement.MassConverstion.code"),
        field: "Code",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("assetManagement.MassConverstion.itemName"),
        field: "Code",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },

      {
        header: t("assetManagement.MassConverstion.serialNumber"),
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: t("assetManagement.MassConverstion.assetLifecycleStage"),
        field: "Name",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("assetManagement.MassConverstion.department"),
        field: "Name",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("assetManagement.MassConverstion.status"),
        field: "ActiveStatus",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        slot: "Status",
      },
      {
        header: "",
        field: "action",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
    ];

    function opendetails(value) {
      showdetails.value = true;
      show.value = value;
    }
    function closedetails() {
      show.value = "";
      showdetails.value = false;
      emit("triggerclose");
    }
    let agreementType = ref();
    const isForm = ref<ScanItemModel>({
      IsNew: false,
      IsModified: false,
      IsDeleted: false,
      IsActive: false,
      CreatedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      ModifiedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      CreatedBy: 0,
      ModifiedBy: 0,
      ItemName: "",
      CreatedByName: "",
      ModifiedByName: "",
      EntityId: 0,
      EntityOperationId: 0,
      DeptRoleId: 0,
      HospitalId: 0,
      BranchId: 0,
      FromStoreBranchId: 0,
      ToStoreBranchId: 0,
      IsEntitySMS: 0,
      OrganizationName: "",
      StockInId: queryform.StockTransId,
      GrnpoNumber: queryform.GrnpoNumber,
      GrnpoId: queryform.GrnpoId,
      BranchName: "",
      FromStoreBranchName: "",
      ToStoreBranchName: "",
      TaskStatus: 0,
      TaskExpiryDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      TaskName: "",
      TaskPriority: 0,
      ResponseTimeInHours: 0,
      IsApprovalRequired: false,
      LevelsOfApproval: 0,
      ModelNo: "",
      Id: 0,
      AssetDisplayId: "",
      StoreID: queryform.StoreId,
      ItemId: 0,
      CategoryId: 0,
      SubCategoryId: 0,
      AssetGroupId: 0,
      SerialNumber: "",
      AssetType: "2",
      PurchaseDate: "",
      PurchaseCost: 0,
      SupplierName: 0,
      PurchaseOrderNumber: "",
      CurrentValue: 0,
      DepreciationMethodID: 1,
      DepreciationRate: 0,
      DepreciationStartDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      MaintenanceScheduleID: 0,
      LocationID: 0,
      StatusID: 0,
      BarCode: "",
      RfidTag: "",
      AssetLifecycleStage: 0,
      UpdatedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      UpdatedBy: "",
      FairMarketValue: 0.0,
      LastFMVAssessmentDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      IssueStatus: 0,
      RequestedBy: "",
      RequestId: 0,
      ToStoreId: queryform.StoreId,
      FromStoreId: queryform.StoreId,
      Type: 0,
      TrackingMechanism: 0,
      StockInDetailId: 0,
      AgreementList: <AgreementList[]>[],
    });
    const locationList = [
      { name: "Full", value: "full" },
      { name: "Partial", value: "partial" },
    ];
    let assetDetails = ref(false);
    const viewAssetdetails = (data) => {
      opendetails("second"), (assetDetails.value = true);
    };
    return {
      assetDetails,
      viewAssetdetails,
      locationList,
      // agreementType,
      loading,
      isForm,
      t,
      sidebarwidth,
      showdetailrightsidebar,
      // opendetailrightsidebar,
      closedetailsrightsidebar,
      opendetails,
      closedetails,
      showdetails,
      show,
      scannedItems,
      selectedProduct,
      headers,
      assetDetailsheaders,
      assetDetailsItems,
      getassetDetailsList,

    };
  },
});
</script>

<style lang="scss" scoped>
.rightdetailssidebar {
  display: flex;
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  transition: all 0.3s ease;
  background: #ffffff;
  border: 1px solid #e1e1e1;
  z-index: 100;

  .sidebar-header {
    position: relative;
    display: flex;
    gap: 10px;
    justify-content: space-between;
    padding: 15px;
    border-bottom: 1px solid #e1e1e1;
    border-right: 1px solid #e1e1e1;

    .pi-arrow-right {
      position: absolute;
      left: -15px;
      top: 60px;
      background: #e1e1e1;
      font-size: 14px;
      height: 30px;
      width: 30px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .firstcontent {
    width: 35rem;
    flex-shrink: 0;
  }

  .secondcontent {
    width: 35rem;
    //flex-shrink: 0;
  }

  .sidebar-content {
    padding: 0px 15px 15px;
    max-height: calc(100vh - 44.8px);
    overflow: auto;
    transition: width 0.3s ease;
    flex-grow: 1;
  }
}

.form-field-column {
  margin: 8px 0px;
}

.display-field-label {
  color: #999999;
  font-size: 14px;
  line-height: 20px;
}

.details-black-field {
  color: #444444;
  font-size: 14px;
}

.small-light-txt {
  font-size: 12px;
  color: #999999;
}
</style>
